import { createFileRoute } from '@tanstack/react-router';
import { SettingsEmail } from '@/pages';

/**
 * Settings Email Route (Protected)
 * Password and email update
 */
export const Route = createFileRoute('/_authenticated/settings/email')({
  component: SettingsEmail,
});
